
import { defineComponent, ref } from "vue";
import CollapsableContainer from "./CollapsableContainer.vue";
import LoadingModal from "./LoadingModal.vue";
import StatusBlock from "./StatusBlock.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import { States, submitHandler } from "./submit_handler";
import { useUserStore } from "@/store/user";

export default defineComponent({
  components: {
    CollapsableContainer,
    Form,
    Field,
    ErrorMessage,
    LoadingModal,
    StatusBlock,
  },
  setup() {
    const user = useUserStore();
    let states: States = {
      recaptcha: null,
      loadingShow: ref(false),
      errorMessage: ref(""),
      captchaEnabled: false,
    };
    let status = ref(false);
    let profile = ref({
      firstName: user.profile?.firstName,
      lastName: user.profile?.lastName,
      username: user.profile?.username,
      email: user.profile?.email,
      phone: user.profile?.phone,
      password: "",
      newPassword: "",
      newPasswordConfirm: "",
    });

    function updateProfile() {
      status.value = true;
      submitHandler(
        user.updateProfile({
          newPassword: profile.value.newPassword,
          password: profile.value.password,
        }),
        states,
        () => {
          profile.value.newPassword = "";
          profile.value.newPasswordConfirm = "";
          profile.value.password = "";
          status.value = false;
          states.errorMessage.value = "Profile updated";
        }
      );
    }

    return {
      errorMessage: states.errorMessage,
      loadingShow: states.loadingShow,
      status,
      profile,
      updateProfile,
    };
  },
});
